import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import router from './router';

Vue.use(Vuex)

export default new Vuex.Store({    
  state: {    
    appversion: '1.8.21d',
    updateRetries: 0,
    usuario:{
      id: '',
      nombre: '',
      vendedor: '',
      userGUID: '',
      salesGroup: '',
      discGroup: '',
      custNo: '',
      custName: '',
      type: '',
      editPrices: false,
      invoiceDisc: [],
      email: '',
      lastEmail: '',
      a: '',
      pagoTarjetaObligatorio: false,
      oneclick: true,
      discPP: 0
    },
    appconfig:{
      name: '',
      name2: '',
      autoventa: false,
      showAppSufix: false,
      defaultOrderType: '',
      showLineCategories: false,
      showItemPhoto: false,
      filterInvoiceDocumentDate: false,
      allowUOMS: false,
      showVAT: false,
      promociones: false,
      NAVversion: '',
      NAVrevision: '',
      servicesLanguage: '',
      enableCustGroups: false,
      redsysEnable: false,
      topItems: 20,
      version: ''
    },
    usuarioLogeado : false,
    items: [], //Resultado de las busquedas
    orderItems: [], //Lineas de pedido
    colorselected: 'blue',
    colornoselected: 'black',
    orderbygroup : false,
    topventas : false,
    onlyAvailable : false,
    onlyPromos : false,
    creatingOrder : false,
    menuitems: [
      {
        active: true,
        action: 'list',
        title: 'Categorías',
        items: []
      }
    ],    
    filter : '', //filtro productos
    custFilter: '',
    loaderData:{
      value: 0,
      query: false,
      show: true,
      interval: 0,
      active: false
    },
    activeAxiosComms:{
      categories: false,
      items: false,
      order: false,
      orderLine: false,
      posting: false,
      customer: false,
      invoices: false,
      anularFactura: false,
      cobrarFactura: false,
      login: false
    },
    calEventDialog: false,
    calEventDialogData: {
      titulo: '',
      contenido: '',
      event: null  
    },
    globalDialog: false,
    globalDialogData: {
      titulo: '',
      contenido: '',
      returnMenu: false     
    },
    adDialog: false,
    adDialogData: {
      titulo: '',
      contenido: '',
      imagen:'',
      visto: false,
      hash:''
    },
    globalConfirmDialog: false,
    globalConfirmDialogData: {
      titulo: '',
      contenido: '',
      returnMenu: false     
    },
    dialogPayment: false,
    dialogPaymentData: {
      titulo: '',
      contenido: '',
      order: '',
      total: 0
    },
    navMenu:[{
        id: 1,
        title: 'Catálogo',
        color: '',
        icon : 'library_books',
        userType: 'all'
    },{
        id: 2,
        title: 'Pedido',
        color: '',
        icon : 'shopping_cart',
        userType: 'all'
    },{
        id: 3,
        title: 'Historial',
        color: '',
        icon : 'playlist_add_check',
        userType: 'all'
    }],
    fechas:[
      {
      text: 'Fecha creación desde',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      },
      {
      text: 'Fecha creación hasta',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      },
      {
      text: 'Fecha registro desde',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      },
      {
      text: 'Fecha registro hasta',
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: ''//this.formatDate(new Date().toISOString().substr(0, 10))
      }
    ],
    dialogComercial: false,
    customer: {No:'', discounts: []},
    customers: [],
    selectedCustIndex: -1,        
    tipoDocumento: '',
    facturas: [],
    facturaActual: [],
    selectedInvIndex: -1,
    dialogInformeComerciales: false,
    tipoInforme: 'Contado',
    dialogTipoCobro: false,
    tipoCobro: 'Efectivo',
    documentNos: [],
    numCheque: 0,
    printhref: '',
    //Dialog Edicion
    dialogEditItem: false,
    dialogData: {
        code: '',
        title: '',
        picture: '',
        pictureLazy: ''
    },                
    editedIndex: -1,
    editedItems: [
      //Se inicializa solo con este campo para que no de problemas el componente de dialogEditItem, que lee este campo en un v-if
      //Si no se pone este valor, da un error de que se intenta acceder a un campo de un valor 'undefined'
      {trackingEnabled: false}
    ],
    sameNoItems: [],
    sameNoItemsBackup: [],    
    //Dialog edicion </>
    //True: abierto, False: cerrado
    menuLateralDrawer: true,
    menuVerticalDrawer: true,
    promosDestacadas: [],
    promosDestacadasVisible: true,
    axiosSource: undefined, //Items
    axiosSourceCustomers: undefined, //Customers
    loginError: false,
    loginErrorMsg: '',
    docNameVisible: false,
    promocionesGrupos: [],
    searchLarge: true,
    buscadorAbierto : false,
    windowSize: {
      x: 0,
      y: 0,
    },
    dialogLastOrder: false,
    dialogLastOrderData: {},
    dialogCreateTodo: false,
    dialogCreateTodoData: {info : {}, notaVisita: '', start: '', end: '', comentarios:  [{comment: '', id: 1}]},
    isMenu: true,
    rutasEventos: [],
    idEvento: '',
    reloadMenu: false,
    clientePotencial: false,
    nombreCP: '',
    visitaPickerDialog: false,
    visitaDate: new Date(Date.now()),
    visitaDateFormatted: '',
    visitaSinPedido: false,
    visitaComentarios: false,
    comentariosHistorial: [],
    lastEpochControlItems: 0,
    Available: [],
    availabilityListVisible: false,
  },
  mutations: {
    increment (state) {
      state.count++
    },
    change(state, flavor) {
      state.flavor = flavor
    },
    loginUser(state, data){           
      //TODO:
      //Pasar alerts a vuetify 
      //var ret = data.return_value; //Slim
      var ret = data.response; //API
			if ((ret == '401')||(ret == '400')){
				if (ret == '401') {
          //$("#popup").html('<p>Contraseña incorrecta</p>');
          //alert('Contraseña incorrecta');
          state.loginError = true;
          state.loginErrorMsg = 'Error en el inicio de sesión';
        }
				else{
					//$("#popup").html('<p>No existe el usuario</p>');
				//$("#popup").popup("open"); 
        //setTimeout(function(){  $("#popup").popup("close"); }, 5000);
          //alert('No existe el usuario');
          state.loginError = true;
          state.loginErrorMsg = 'Error en el inicio de sesión';
        }
			} else {				     
        state.usuario.nombre = data.name;
        state.usuario.vendedor = data.salesperson;
        //state.usuario.userGUID = '{' + data[0].guid + '}';
        state.usuario.userGUID = ret;
        state.usuario.salesGroup = data.custPriceGroup;
        state.usuario.discGroup = data.custDiscGroup;
        state.usuario.custNo = data.custNo;
        state.usuario.type = data.type;
        state.usuario.editPrices = data.editPrices;
        state.usuario.invoiceDisc = data.invoiceDisc;
        state.usuario.custName = data.custName;
        state.usuario.email = data.email;
        state.usuario.lastEmail = data.email;        
        state.usuario.a = data.a;
        state.usuario.discPP = data.discPP;
        state.usuario.appCustGroup = data.appCustGroup;
        state.usuario.locationCode = data.locationCode;
        if (data.pagoTarjetaObligatorio == "1")
          state.usuario.pagoTarjetaObligatorio = true;
        else
          state.usuario.pagoTarjetaObligatorio = false;
        state.usuario.oneclick = data.oneclick;
        state.usuarioLogeado = true;   
        if ((state.usuario.type == 'Comercial') &&(state.orderItems = [])) {          
          state.dialogComercial = true;
        }
        if (data.currentCart != ''){
          //var lines = JSON.parse(data.currentCart);
          //state.orderItems = lines;
          state.usuario.currentCart = JSON.parse(data.currentCart);
        } else {
          state.usuario.currentCart = '';
        }
        //console.log(data);            
			}
    },    
    setOneClick(state,value){
      state.usuario.oneclick = value;
    },
    setUserA(state,value){
      state.usuario.a = value;
    },
    saveUserId(state,value){
      state.usuario.id = value;      
    },
    logout(state){
      state.usuarioLogeado = false;
      state.usuario = {
        id: '',
        nombre: '',
        vendedor: '',
        userGUID: '',
        salesGroup: '',
        custNo: ''      
      };
      this.commit('resetOrderItems');
      this.commit('resetTaskData');
      router.push('/');
    },
    logoutInternal(state){
      state.usuarioLogeado = false;
      state.usuario = {
        id: '',
        nombre: '',
        vendedor: '',
        userGUID: '',
        salesGroup: '',
        custNo: ''      
      };
    },
    setOrderItems(state,value){
      state.orderItems = value;
    },
    resetOrderItems(state){      
      state.tipoDocumento = '';
      state.orderItems = [];      
    },
    setOrderByGroup(state, value){
      state.orderbygroup = value;
    },
    setTopVentas(state,value){
      state.topventas = value;
    },
    setMenuItems(state,value){
      state.menuitems = value;
    },
    setItems(state, value){
      state.items = value;
    },
    setItemsFilter(state, value){
      state.filter = value;
    },
    flipLoading(state){
      state.creatingOrder = !state.creatingOrder;
    },
    setLoading(state){
      state.creatingOrder = true;
    },
    cancelLoading(state){
      state.creatingOrder = false;
    },
    showGlobalLoader(state){
      //Timeout 20s
      state.loaderData.active = true;
      setTimeout(() => {
          state.loaderData.active = false;
      },30000);
    },
    hideGlobalLoader(state){
      if ((!state.activeAxiosComms.categories) &&
        (!state.activeAxiosComms.items) &&
        (!state.activeAxiosComms.order) &&
        (!state.activeAxiosComms.orderLine) &&
        (!state.activeAxiosComms.posting) &&
        (!state.activeAxiosComms.customer) &&
        (!state.activeAxiosComms.invoices)
        ){
          state.loaderData.active = false;
        }      
    },
    setGlobalDialog(state,value){
      state.globalDialog = value;
    },
    setAdDialog(state,value){
      state.adDialog = value;
    },
    setAdDialogData(state,value){
      state.adDialogData = value;
    },
    setCalEventdialog(state,value){
      state.calEventDialog = value;
    },
    setHourEnd(state,data){
      state.dialogCreateTodoData.end = data;
    },
    setHourStart(state,data){
      state.dialogCreateTodoData.start = data;
    },
    setNavMenu(state,value){
      state.navMenu = value;
    },
    setCustFilter(state,value){
      state.custFilter = value;
    },
    setCustomers(state,value){
      state.customers = value;
    },
    setSelectedCust(state, value){
      state.selectedCustIndex = value;
    },
    setTipoDocumento(state,value){
      state.tipoDocumento = value;
    },
    setDialogComercial(state,value){
      state.dialogComercial = value;
    },
    setDialogPaymentData(state,value){
      state.dialogPaymentData = value;
    },
    setSelectedInvoice(state,value){
      state.selectedInvIndex = value;
    },
    setDates(state,value){
      state.fechas = value;
    },
    setInvoices(state,value){
      state.facturas = value;
    },
    setSearchLarge(state,value){
      state.searchLarge = value;
    },
    setBuscadorAbierto(state,value){
      state.buscadorAbierto = value;
    },
    setPromos(state,value){
      state.promosDestacadas = value;
    },
    setPromosVisible(state,value){
      state.promosDestacadasVisible = value;
    },
    setCustomerLoading(state,value){
      state.activeAxiosComms.customer = value;
    },
    setIsMenu(state,value){
      state.isMenu = value;
    },
    setUpdateRetries(state,value){
      state.updateRetries = value;
    },
    setRutas(state,value){
      state.rutasEventos = value;
    },
    setNotaVisita(state,value){
      state.dialogCreateTodoData.notaVisita = value;
    },
    setComentarioVisita(state,value){
      state.dialogCreateTodoData.comentario = value;
    },
    setComentariosVisita(state,value){
      state.dialogCreateTodoData.comentarios = value;
    },
    setComentariosVisitaHistorial(state,value){
      state.comentariosHistorial = value;
    },
    setClientePotencial(state,value){
      state.clientePotencial = value;
    },
    setNombreCP(state,value){
      state.nombreCP = value;
    },
    setVisitaDate(state,value){
      state.visitaDate = value;
    },
    setVisitaDateFormatted(state,value){
      state.visitaDateFormatted = value;
    },
    setEpochControlItems(state,value){
      state.lastEpochControlItems = value;
    },
    setAvailable(state,value){
      state.Available = value;
    },
    resetTaskData(state){
      state.idEvento = '';
      state.clientePotencial = '';
      state.nombreCP = '';
      state.visitaDate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      state.visitaDateFormatted = '';
      state.visitaSinPedido = false;
      state.visitaComentarios = false;
      state.dialogCreateTodoData = {info : {}, notaVisita: '', start: '', end: '', comentarios:  [{comment: '', id: 1}]};
    },
    setCustomer(state,value){
      state.customer = value;
    },
  },
  actions: {
    getItems(store){
      ///items/false/' + getCookie('usuario') + '/' + getCookie('userGUID') + '/-1/-1/' + filter,      
    }    
  },
  getters: {
    flavor: state => state.flavor,
    count: state => state.count,  
    usuario: state => state.usuario,
    nombreUsuario: state => state.nombreUsuario,
  },  
  //Variables que se guardan de manera permantente incluso si se actualiza la página
  plugins: [createPersistedState({
    key: 'AppData',
    paths: ['usuario','usuarioLogeado','orderItems','orderbygroup','topventas','onlyAvailable','menuitems','items', 'idEvento', 'dialogCreateTodoData', 'visitaSinPedido', 'visitaComentarios', 'customer',
        'customers','selectedCustIndex','tipoDocumento','filter','appconfig','custFilter','docNameVisible', 'dialogPaymentData','searchLarge','buscadorAbierto','updateRetries','lastEpochControlItems','adDialogData']
  })] 
})
